import Axios from "axios";
import { SERVER_CONFIG } from "../config";
const { API_URL } = SERVER_CONFIG[process.env.NODE_ENV || "production"];

class EmailService {
  async sendEmailContact(req) {
    return Axios.post(`${API_URL}api/send-email-contact`, req).then((res) => res.data || {});
  }
}

export default new EmailService();
